// src/Utils/inventoryMenuMap.js

export const INVENTORY_CATEGORY_MAP = {
  // ================================================================
  // 1. E-COMMERCE (id: 1)
  // Business: Online selling — warehouse + product variety zaroori
  // ================================================================
  "E-commerce": {
    _default: ["product", "category", "subcategory", "brand", "wherehouse"],
    "Fashion": ["product", "category", "subcategory", "brand", "color", "size", "wherehouse"],
    "Electronics": ["product", "category", "subcategory", "brand", "unit", "wherehouse"],
    "Grocery": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Furniture": ["product", "category", "subcategory", "brand", "size", "wherehouse"],
    "Beauty": ["product", "category", "subcategory", "brand", "color", "wherehouse"],
    "Jewelry": ["product", "category", "subcategory", "brand", "size", "wherehouse"],
    "Pet Store": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Books": ["product", "category", "subcategory", "wherehouse"],
    "Toys": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Sports": ["product", "category", "subcategory", "brand", "size", "wherehouse"],
    "Automotive Parts": ["product", "category", "subcategory", "brand", "unit", "wherehouse"],
  },

  // ================================================================
  // 2. RETAIL (id: 2)
  // Business: Physical store — warehouse + stock transfer zaroori
  // ================================================================
  "Retail": {
    _default: ["product", "category", "subcategory", "stocktransfer", "wherehouse"],
    "Clothing Store": ["product", "category", "subcategory", "color", "size", "wherehouse"],
    "Supermarket": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Pharmacy": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Gift Shop": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Stationery": ["product", "category", "subcategory", "wherehouse"],
    "Mobile Store": ["product", "category", "subcategory", "brand", "unit", "wherehouse"],
    "Shoe Store": ["product", "category", "subcategory", "color", "size", "wherehouse"],
  },

  // ================================================================
  // 3. MANUFACTURING (id: 3)
  // Business: Raw material → Finished goods
  // purchase, suppliers, warehouse, stock transfer zaroori
  // ================================================================
  "Manufacturing": {
    _default: ["product", "purchase", "suppliers", "wherehouse", "stocktransfer"],
    "Textile": ["product", "purchase", "suppliers", "wherehouse", "color", "stocktransfer"],
    "Food Processing": ["product", "purchase", "suppliers", "wherehouse", "unit", "stocktransfer"],
    "Chemicals": ["product", "purchase", "suppliers", "wherehouse", "unit", "stocktransfer"],
    "Machinery": ["product", "purchase", "suppliers", "wherehouse", "stocktransfer"],
    "Plastic": ["product", "purchase", "suppliers", "wherehouse", "unit", "stocktransfer"],
    "Metal Fabrication": ["product", "purchase", "suppliers", "wherehouse", "unit", "stocktransfer"],
    "Electronics Manufacturing": ["product", "purchase", "suppliers", "wherehouse", "brand", "stocktransfer"],
  },

  // ================================================================
  // 4. INFORMATION TECHNOLOGY (id: 4)
  // Business: Software/IT services — physical inventory nahi
  // ================================================================
  "Information Technology": {
    _default: ["product", "category", "subcategory"],
    "Software Company": ["product", "category", "subcategory"],
    "SaaS": ["product", "category", "subcategory"],
    "Mobile App Development": ["product", "category", "subcategory"],
    "Web Development": ["product", "category", "subcategory"],
    "AI Company": ["product", "category", "subcategory"],
    "Cybersecurity": ["product", "category", "subcategory"],
    "IT Services": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 5. HEALTHCARE (id: 5)
  // Business: Hospital/Pharmacy — medicines store karne ke liye warehouse
  // ================================================================
  "Healthcare": {
    _default: ["product", "category", "subcategory", "unit", "wherehouse"],
    "Hospital": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Clinic": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Dental Clinic": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Pharmacy": ["product", "category", "subcategory", "unit", "brand", "wherehouse"],
    "Laboratory": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Physiotherapy": ["product", "category", "subcategory"],
    "Veterinary": ["product", "category", "subcategory", "unit", "wherehouse"],
  },

  // ================================================================
  // 6. EDUCATION (id: 6)
  // Business: School/College — physical inventory nahi
  // ================================================================
  "Education": {
    _default: ["product", "category", "subcategory"],
    "School": ["product", "category", "subcategory"],
    "College": ["product", "category", "subcategory"],
    "University": ["product", "category", "subcategory"],
    "Coaching Center": ["product", "category", "subcategory"],
    "Online Learning": ["product", "category", "subcategory"],
    "Training Institute": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 7. REAL ESTATE (id: 7)
  // Business: Property dealing — physical inventory nahi
  // Builder ke liye warehouse (construction material)
  // ================================================================
  "Real Estate": {
    _default: ["product", "category", "subcategory"],
    "Residential": ["product", "category", "subcategory"],
    "Commercial": ["product", "category", "subcategory"],
    "Property Dealer": ["product", "category", "subcategory"],
    "Builder": ["product", "category", "subcategory", "wherehouse"],
    "Interior Design": ["product", "category", "subcategory", "color"],
    "Property Delar": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 8. CONSTRUCTION (id: 8)
  // Business: Building — construction material warehouse zaroori
  // ================================================================
  "Construction": {
    _default: ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Contractor": ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Civil Engineering": ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Architecture": ["product", "category", "subcategory"],
    "Plumbing": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Electrical Services": ["product", "category", "subcategory", "unit", "wherehouse"],
  },

  // ================================================================
  // 9. FINANCE (id: 9)
  // Business: Accounting/Tax/Insurance — physical inventory nahi
  // ================================================================
  "Finance": {
    _default: ["product", "category", "subcategory"],
    "Accounting": ["product", "category", "subcategory"],
    "Tax Consultant": ["product", "category", "subcategory"],
    "Insurance": ["product", "category", "subcategory"],
    "Investment": ["product", "category", "subcategory"],
    "Banking": ["product", "category", "subcategory"],
    "Loan Agency": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 10. HOSPITALITY (id: 10)
  // Business: Hotel/Restaurant — food, beverages warehouse zaroori
  // ================================================================
  "Hospitality": {
    _default: ["product", "category", "subcategory", "unit", "wherehouse"],
    "Hotel": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Resort": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Restaurant": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Cafe": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Bakery": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Catering": ["product", "category", "subcategory", "unit", "wherehouse"],
  },

  // ================================================================
  // 11. LOGISTICS (id: 11)
  // Business: Courier/Freight — warehouse + stock transfer core business
  // ================================================================
  "Logistics": {
    _default: ["product", "wherehouse", "stocktransfer"],
    "Courier": ["product", "wherehouse", "stocktransfer"],
    "Freight": ["product", "wherehouse", "stocktransfer"],
    "Warehousing": ["product", "wherehouse", "stocktransfer"],
    "Transport": ["product", "wherehouse", "stocktransfer"],
    "Movers & Packers": ["product", "wherehouse", "stocktransfer"],
  },

  // ================================================================
  // 12. AUTOMOTIVE (id: 12)
  // Business: Vehicles/Spare parts — warehouse zaroori
  // ================================================================
  "Automotive": {
    _default: ["product", "category", "subcategory", "brand", "wherehouse"],
    "Car Dealer": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Bike Dealer": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Repair Garage": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Car Rental": ["product", "category", "subcategory"],
    "Spare Parts": ["product", "category", "subcategory", "brand", "wherehouse"],
  },

  // ================================================================
  // 13. BEAUTY & WELLNESS (id: 13)
  // Business: Salon/Spa/Cosmetics — products store karne ke liye warehouse
  // ================================================================
  "Beauty & Wellness": {
    _default: ["product", "category", "subcategory", "brand", "wherehouse"],
    "Salon": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Spa": ["product", "category", "subcategory", "brand", "wherehouse"],
    "Gym": ["product", "category", "subcategory", "wherehouse"],
    "Yoga Studio": ["product", "category", "subcategory"],
    "Cosmetics": ["product", "category", "subcategory", "brand", "color", "wherehouse"],
  },

  // ================================================================
  // 14. AGRICULTURE (id: 14)
  // Business: Farming/Dairy — seeds, fertilizers warehouse zaroori
  // ================================================================
  "Agriculture": {
    _default: ["product", "category", "subcategory", "unit", "wherehouse"],
    "Farming": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Dairy": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Poultry": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Seeds": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Fertilizers": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Agricultural Equipment": ["product", "category", "subcategory", "unit", "brand", "wherehouse"],
  },

  // ================================================================
  // 15. TRAVEL (id: 15)
  // Business: Travel agency — physical inventory nahi
  // ================================================================
  "Travel": {
    _default: ["product", "category", "subcategory"],
    "Travel Agency": ["product", "category", "subcategory"],
    "Tour Operator": ["product", "category", "subcategory"],
    "Visa Services": ["product", "category", "subcategory"],
    "Ticket Booking": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 16. MEDIA & ENTERTAINMENT (id: 16)
  // Business: Advertising/Photography — physical inventory nahi
  // ================================================================
  "Media & Entertainment": {
    _default: ["product", "category", "subcategory"],
    "Advertising": ["product", "category", "subcategory"],
    "Digital Marketing": ["product", "category", "subcategory"],
    "Event Management": ["product", "category", "subcategory"],
    "Photography": ["product", "category", "subcategory"],
    "Video Production": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 17. LEGAL (id: 17)
  // Business: Law firm — physical inventory nahi
  // ================================================================
  "Legal": {
    _default: ["product", "category", "subcategory"],
    "Law Firm": ["product", "category", "subcategory"],
    "Advocate": ["product", "category", "subcategory"],
    "Notary": ["product", "category", "subcategory"],
    "Legal Consultant": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 18. NON-PROFIT (id: 18)
  // Business: NGO/Charity — physical inventory nahi
  // ================================================================
  "Non-Profit": {
    _default: ["product", "category", "subcategory"],
    "NGO": ["product", "category", "subcategory"],
    "Charity": ["product", "category", "subcategory"],
    "Foundation": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 19. TELECOMMUNICATIONS (id: 19)
  // Business: SIM/Equipment — warehouse zaroori
  // ================================================================
  "Telecommunications": {
    _default: ["product", "category", "subcategory", "unit", "wherehouse"],
    "Internet Provider": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Mobile Operator": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Telecom Services": ["product", "category", "subcategory", "unit", "wherehouse"],
  },

  // ================================================================
  // 20. ENERGY (id: 20)
  // Business: Solar/Wind — panels, equipment warehouse zaroori
  // ================================================================
  "Energy": {
    _default: ["product", "category", "subcategory", "unit", "wherehouse"],
    "Solar": ["product", "category", "subcategory", "unit", "brand", "wherehouse"],
    "Wind": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Electrical Contractor": ["product", "category", "subcategory", "unit", "wherehouse"],
    "Oil & Gas": ["product", "category", "subcategory", "unit", "wherehouse"],
  },

  // ================================================================
  // 21. HOME SERVICES (id: 21)
  // Business: Cleaning/Pest control — chemicals, tools store
  // ================================================================
  "Home Services": {
    _default: ["product", "category", "subcategory"],
    "Cleaning": ["product", "category", "subcategory", "wherehouse"],
    "Pest Control": ["product", "category", "subcategory", "wherehouse"],
    "Security Services": ["product", "category", "subcategory"],
    "Home Maintenance": ["product", "category", "subcategory", "wherehouse"],
  },

  // ================================================================
  // 22. PROFESSIONAL SERVICES (id: 22)
  // Business: Consultant/HR — physical inventory nahi
  // ================================================================
  "Professional Services": {
    _default: ["product", "category", "subcategory"],
    "Consultant": ["product", "category", "subcategory"],
    "HR Agency": ["product", "category", "subcategory"],
    "Recruitment": ["product", "category", "subcategory"],
    "Business Consulting": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 23. WHOLESALE (id: 23)
  // Business: Bulk selling — warehouse + stock transfer core business
  // ================================================================
  "Wholesale": {
    _default: ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Distributor": ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Importer": ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Exporter": ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
    "Supplier": ["product", "category", "subcategory", "wherehouse", "stocktransfer"],
  },

  // ================================================================
  // 24. GOVERNMENT (id: 24)
  // Business: Municipality/Public dept — physical inventory nahi
  // ================================================================
  "Government": {
    _default: ["product", "category", "subcategory"],
    "Municipality": ["product", "category", "subcategory"],
    "Public Department": ["product", "category", "subcategory"],
    "Government Office": ["product", "category", "subcategory"],
  },

  // ================================================================
  // 25. GROCERY (id: 25)
  // Business: Grocery store — stock store karne ke liye warehouse
  // ================================================================
  "Grocery": {
    _default: ["product", "category", "subcategory", "unit", "wherehouse"],
    "Cooking Oil": ["product", "category", "subcategory", "unit", "brand", "wherehouse"],
  },

  // ================================================================
  // 26. ELECTRONICS (id: 26)
  // Business: Electronics selling — warehouse + brand + unit zaroori
  // ================================================================
  "Electronics": {
    _default: ["product", "category", "subcategory", "brand", "unit", "wherehouse"],
  },
};

/**
 * Inventory menu IDs ko resolve karo based on category/subcategory
 * @param {string} categoryName - Category name (e.g., "E-commerce")
 * @param {string} subcategoryName - Subcategory name (e.g., "Toys")
 * @returns {string[]} - Array of menu IDs
 */
export const getInventoryMenuIds = (categoryName, subcategoryName) => {
  if (!categoryName || !INVENTORY_CATEGORY_MAP[categoryName]) {
    return [];
  }

  const catMap = INVENTORY_CATEGORY_MAP[categoryName];

  // Specific subcategory mapping
  if (subcategoryName && catMap[subcategoryName]) {
    return catMap[subcategoryName];
  }

  // Default mapping
  return catMap._default || [];
};